import styled from 'styled-components'

const MyDiv = styled.div`
.dialog_title{
    padding: 0px 0px;
    font-weight: 600;
    font-family: "Arial";
    font-size: 18px;
    color: #000;
}
.dialog_box{
    padding: 0px 20px;
}
.dialog_header{
    display: flex;
    align-items: center;
    justify-content: end;
}
.dialog_content{
    padding: 20px 0px 10px;
    margin:10px;
}
.dialog_box{
    padding: 0px 20px;
}
.icon{
 color: #000;
}
.d-flex{
    display: flex;
    width: 100%
    justify-content: end;
    column-gap: 20px;
}
.mb-20{
    margin-bottom:15px;
}

`
export default MyDiv
